import { RequestBuildingsParams, Building } from 'app/common/types/buildings'
import { BuildingId } from 'app/common/types/id'
import type { Request } from '../../../index'

type UrlParams = {
  orgId: string
}

export const convertParams = (params: RequestBuildingsParams): [null, UrlParams] => {
  const { orgId } = params
  return [null, { orgId }]
}

export const convertResult = (
  categories: Record<string, { id: number; title: string }>,
): Array<Building> => {
  return Object.values(categories).map(({ id, title }) => ({ id: String(id) as BuildingId, title }))
}

export const GET_BUILDINGS: Request<RequestBuildingsParams, Array<Building>, UrlParams> = [
  'food/schools/{orgId}/buildings',
  'get',
  ['data', 'buildings'],
]
